import { UserRole } from '../../../shared/enums';

const PermissionsOfPackagePrices = {
  EditPrices: [UserRole.ADMIN],
  SeeListOfPrices: [UserRole.ADMIN, UserRole.EDITOR, UserRole.CUSTOMER],
  MakeRequests: [UserRole.CUSTOMER],
  SeeEditPriceMessage: [UserRole.ADMIN, UserRole.EDITOR],
};

export default PermissionsOfPackagePrices;
